import { h } from "preact";

/**
		A button - without any 'active' settings		
		
		AVAILABLE PARAMETERS:

		className (string)
		- adds to the buttons css class string

		icon (string e.g. 'fa-clock')
		- the fontawesome 4 class name 
		- https://fontawesome.com/v4.7.0/cheatsheet/

		idName (string)
		- gives the button an id for query selection

		onClick (function)
		- overrides the click event handler for the button 

		title (string)
		- used for browser default hover text. If tooltips are specified, becomes the tooltip text only

		tooltipStyle ('attach', 'float', 'none')
		- 'attach'	- tooltip is always visible and acts as a label inside the button
		- 'float'		- a traditional tooltip that only displays when the button is hovered and is disconnected from the button itself

		tooltipPosition ('left', 'right')

		href (string)
		- the href attribute of the buttons anchor tag
*/

export const Button = (props) => {
	const {
		href,
		target,
		title,
		icon,
		tooltipStyle = "attach",
		onClick,
		className,
		idName,
		badgeCount,
		onMouseOver,
		onMouseOut,
	} = props;
	let tooltipPosition = props.tooltipPosition;
	let classes = "vf-navbtn";

	if (!tooltipPosition && !icon) {
		tooltipPosition = "right";
	}

	if (className) {
		classes += ` ${className}`;
	}

	return (
		<a
			id={idName}
			className={classes}
			onClick={onClick}
			onMouseOver={onMouseOver}
			onMouseOut={onMouseOut}
			href={href}
			target={target}
			title={!tooltipPosition ? title : null}
			data-tooltip={tooltipStyle !== "none" ? title : null}
			data-tooltip-position={tooltipPosition}
			data-tooltip-style={tooltipStyle}
		>
			{icon != undefined && typeof icon === "string" ? (
				<i
					class={`fa ${icon}`}
					data-badge-count={badgeCount ? badgeCount : null}
				/>
			) : (
				icon
			)}
		</a>
	);
};
